import {HTTPServer} from '@/common/js/ajax.js'
import {additionalType, reductionType} from '@/common/js/constant.js'
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      vOptions: [], // 版本
      funAuth: [],
      funAuth2: [], // 子模块
      logList: [],
      moduleIds: [],
      featureData: {data: [], type: 1} // 功能清单
    }
  },
  methods: {
    /** 获取模块权限 */
    queryFchBtnAuth (params) {
      HTTPServer.queryFchBtnAuth(params, '').then((res) => {
        res.map((item, index) => {
          this.funAuth.push(item.func_id)
        })
        this.setCurrentPermission(this.funAuth)
        console.log(this.funAuth)
        console.log(this.currentPermission)
      })
    },
    /** 获取模块权限 */
    queryFchBtnAuth2 (params) {
      this.funAuth2 = []
      HTTPServer.queryFchBtnAuth(params, '').then((res) => {
        res.map((item, index) => {
          this.funAuth2.push(item.func_id)
        })
      })
    },
    /** 功能清单 - 数据整理至后台 */
    featureInit (arr) {
      let arr2 = []
      arr.map((models) => {
        let f = []
        models.funcList.map((fun) => {
          fun.choice = '0'
          if (fun.checked) {
            f.push(fun.id)
            fun.choice = '1'
          }
          // delete fun.checked
        })
        if (f.length > 0) arr2.push({'commodity_type': models.type, 'funcAuthList': f.toString()})
      })
      return arr2
    },
    /**
     * 返回为禁用已选的数据
     *  功能清单 - 数据整理至后台 */
    featureInit2 (arr, type) {
      let arr2 = []
      arr.map((models) => {
        let f = []
        models.funcList.map((fun) => {
          fun.choice = '0'
          if (fun.checked) {
            fun.choice = '1'
            if (!fun.disabled) {
              fun.from_type = type
              f.push(fun.id)
            }
          }
          // delete fun.checked
        })
        if (f.length > 0) arr2.push({'commodity_type': models.type, 'funcAuthList': f.toString()})
      })
      return arr2
    },
    // 获取主模块权限
    getFunAuth () {
      console.log(this.currentPermission)
      this.funAuth = JSON.parse(JSON.stringify(this.currentPermission))
    },
    /** 获取所有版本 */
    queryAllChargingStrategy (type) {
      HTTPServer.queryAllChargingStrategy({}, 'Loading').then((res) => {
        this.vOptions = res
        if (type && res.length > 0) {
          this.version = res[0].id
        }
      })
    },
    /** 版本初始化 */
    editionInit (id) {
      var value = ''
      this.vOptions.map((item) => {
        if (parseInt(item.id) === parseInt(id)) {
          value = item.version_name
        }
      })
      return value
    },
    /** 获取功能清单 */
    queryCommodityList (params) {
      HTTPServer.queryCommodityList(params, 'Loading').then((res) => {
        this.featureData = {data: res, type: 1}
      })
    },
    /** 获取功能清单 */
    getCustomerCommodityList (params) {
      HTTPServer.getCustomerCommodityList(params, 'Loading').then((res) => {
        this.featureData = {data: res, type: 1}
      })
    },
    /** 增购解析 */
    afieldInit (type) {
      let name = '-'
      additionalType.map((item) => {
        if (item.value === type) {
          name = item.label
        }
      })
      return name
    },
    /** 减购解析 */
    redfieldInit (type) {
      let name = '-'
      reductionType.map((item) => {
        if (item.value === type) {
          name = item.label
        }
      })
      return name
    },
    /**
     * 模块日志类型 1 注册客户 2 试用客户 3 正式客户 4 增购 5 减购 6 续费 7 邀请码 8 收费策略 9 已发布应用 10 待审核应用 11 精品应用 12 账号管理 13 角色权限 14 修改密码
     */
    queryRecordList (jsondata) {
      jsondata.pageNum = 1
      jsondata.pageSize = 9999
      HTTPServer.queryRecordList(jsondata, 'Loading').then((res) => {
        this.logList = res.dataList
      })
    },

    ...mapMutations({
      setPermissionData: 'PERMISSION', // 所有权限表
      setCurrentPermission: 'CURRENT_PERMISSION' // 当前模块权限
    })
  },
  mounted () {
    console.log(this.permissionData)
    this.moduleIds = []
    this.permissionData.map((item) => {
      this.moduleIds.push(item.moduleId)
    })
    console.log(this.moduleIds)
  },
  watch: {
    permissionData () {
      console.log(this.permissionData)
      this.moduleIds = []
      this.permissionData.map((item) => {
        this.moduleIds.push(item.moduleId)
      })
      console.log(this.moduleIds)
    }
  },
  computed: {
    ...mapState({
      permissionData: state => state.permission.permissionData, // 所有权限表
      currentPermission: state => state.permission.currentPermission // 当前模块权限
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/js/mixins.js